module.exports = __webpack_public_path__ + "img/pause_watch.eb924a02.svg";